export default __webpack_public_path__ + "static/media/Amra's Pride.708a5e63.jpg";